<template>
  <div class="footer-wrapper">
    <FooterWrapper/>
  </div>
</template>

<script>
import FooterWrapper from './FooterWrapper.vue'
export default {
    name: 'HomeFooter',
    setup(){
      return{
      }
    },
    components: {
      FooterWrapper
    }
}
</script>

<style scoped>
.footer-wrapper{
  border-top: .5rem solid var(--primary-color);
}

.footer__header{
  border-bottom: .1rem solid #ccc;
}

.footer__category__wrapper-contains__link{
  color: rgba(0,0,0,.54);
}

.footer__category__wrapper-contains__link:hover{
  color: var(--primary-color)
}

.footer__category__wrapper-contains__link::before{
  position: absolute;
  content: '';
  display: block;
  height: 1.5rem;
  width: 1px;
  background-color: rgb(173, 172, 172);
  right: 0;
  margin: 0 .3rem;
}

.footer__category__wrapper-contains__link:last-child::before{
  display: none;
}

/* mobile & tablet */
@media (max-width: 1023px){
    .footer{
      padding: 1rem 2rem;
    }

    .footer__category{
      display: none;
    }
}

/* mobile */
@media (max-width: 739px){
    
    
}
</style>